import React from 'react';
import ProductSearchComponent from '../../../components/productos/Buscador/Buscador';

const ProductSearch = ({ token }) => {
  
  return (
    <div>
      <ProductSearchComponent
          token={token}
          showActions={true}
          showPrintLabel={true}
          syncUrl
        />
    </div>
  );
};

export default ProductSearch;